






















import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import TileComponents from '@/components/tiles';
import { BModal } from 'bootstrap-vue';
import { Mutation } from 'vuex-class';
import _ from 'lodash';


interface ITileInfo {
    key: string;
    available: boolean;
}

@Component({
    components: {
        ...TileComponents,
    },
})
export default class TilesPicker extends Vue {
    @Prop({required: true})
    public deviceNumber: string;

    public tiles: ITileInfo[] = [];

    public get tilesSorted(): ITileInfo[] {
        const result = _.sortBy(this.tiles, [(u) => !u.available, 'key']);
        return result;
    }


    public mounted() {
        this.tiles.length = 0;
        for (const key in TileComponents) {
            if (key) {
                this.tiles.push({
                    key,
                    available: false,
                });
            }
        }
    }

    public showModal() {
        (this.$refs['tiles-picker-modal'] as BModal).show();
    }
    public closeModal() {
        (this.$refs['tiles-picker-modal'] as BModal).hide();
    }
    public create(type: string, configuration: any) {
        this.$emit('save', {type, configuration});
        (this.$refs['tiles-picker-modal'] as BModal).hide();
    }
}
